// extracted by mini-css-extract-plugin
export default {"menu":"lbJoJ"};